var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8974_18508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3846 2.76923H16.022L15.2209 0.524176C15.1655 0.370553 15.0641 0.237763 14.9305 0.143945C14.7968 0.0501265 14.6375 -0.000144054 14.4742 3.10062e-07H6.88846C6.55467 3.10062e-07 6.25549 0.210165 6.14423 0.524176L5.34066 2.76923H1.97802C0.885165 2.76923 0 3.6544 0 4.74725V16.022C0 17.1148 0.885165 18 1.97802 18H19.3846C20.4775 18 21.3626 17.1148 21.3626 16.022V4.74725C21.3626 3.6544 20.4775 2.76923 19.3846 2.76923ZM19.5824 16.022C19.5824 16.1308 19.4934 16.2198 19.3846 16.2198H1.97802C1.86923 16.2198 1.78022 16.1308 1.78022 16.022V4.74725C1.78022 4.63846 1.86923 4.54945 1.97802 4.54945H6.59423L7.01703 3.36758L7.58324 1.78022H13.7769L14.3431 3.36758L14.7659 4.54945H19.3846C19.4934 4.54945 19.5824 4.63846 19.5824 4.74725V16.022ZM10.6813 6.13187C8.4956 6.13187 6.72527 7.9022 6.72527 10.0879C6.72527 12.2736 8.4956 14.044 10.6813 14.044C12.867 14.044 14.6374 12.2736 14.6374 10.0879C14.6374 7.9022 12.867 6.13187 10.6813 6.13187ZM10.6813 12.4615C9.37088 12.4615 8.30769 11.3984 8.30769 10.0879C8.30769 8.77747 9.37088 7.71429 10.6813 7.71429C11.9918 7.71429 13.0549 8.77747 13.0549 10.0879C13.0549 11.3984 11.9918 12.4615 10.6813 12.4615Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8974_18508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4c292d4916c504f2a5185c15e95006cf.svg";
export { ForwardRef as ReactComponent };